<template>
  <div class="basket-price-list">
    <basket-price-list-desktop
      :headline="headline"
      :total-price-label="totalPriceLabel"
      :total-fees-label="totalFeesLabel"
      :per-year-label="perYearLabel"
      :proposals="proposals"
      :total-price="totalPrice"
      :total-fees="totalFees"
      :digital-bonus-label="digitalBonusLabel"
      :digital-bonus-tooltip="digitalBonusTooltip"
      :year-zero-text="yearZeroText"
      :year-zero-modal="yearZeroModal"
    >
      <template #actions>
        <slot name="actions" />
      </template>
    </basket-price-list-desktop>

    <basket-price-list-mobile
      :headline="headline"
      :total-price-label="totalPriceLabel"
      :total-fees-label="totalFeesLabel"
      :per-year-label="perYearLabel"
      :proposals="proposals"
      :total-price="totalPrice"
      :total-fees="totalFees"
      :digital-bonus-label="digitalBonusLabel"
      :digital-bonus-tooltip="digitalBonusTooltip"
      :year-zero-text="yearZeroText"
      :year-zero-modal="yearZeroModal"
    >
      <template #actions>
        <slot name="actions" />
      </template>
    </basket-price-list-mobile>
  </div>
</template>
<script lang="ts">
import BasketPriceListDesktop from './BasketPriceListDesktop.vue';
import BasketPriceListMobile from './BasketPriceListMobile.vue';
import { ProposalPriceModel } from './types/ProposalPriceList';
import { ChildYearZeroModal } from '@/components/Feature/ProposalBasket/types/ProposalBasket';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'BasketPriceList',
  components: {
    BasketPriceListDesktop,
    BasketPriceListMobile
  },
  props: {
    proposals: {
      type: Array as PropType<Array<ProposalPriceModel>>,
      default: () => [] as ProposalPriceModel[]
    },
    headline: {
      type: String,
      default: () => ''
    },
    totalPriceLabel: {
      type: String,
      default: () => ''
    },
    totalFeesLabel: {
      type: String,
      default: () => ''
    },
    perYearLabel: {
      type: String,
      default: () => ''
    },
    totalPrice: {
      type: String,
      default: () => ''
    },
    totalFees: {
      type: String,
      default: () => ''
    },
    digitalBonusLabel: {
      type: String,
      default: () => ''
    },
    digitalBonusTooltip: {
      type: String,
      default: () => ''
    },
    yearZeroText: {
      type: String,
      default: () => ''
    },
    yearZeroModal: {
      type: Object as PropType<ChildYearZeroModal>,
      default() {
        return {
          textLink: '',
          title: '',
          textContent: '',
          closeBtn: ''
        };
      }
    }
  }
});
</script>
